import React from 'react';
import './styles.css';

/**
 * 表單複選框組件
 * 用於創建帶有標籤和幫助文本的複選框
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.id - 複選框ID
 * @param {string} props.name - 複選框名稱
 * @param {string} props.label - 複選框標籤
 * @param {boolean} props.checked - 是否選中
 * @param {Function} props.onChange - 變更處理函數
 * @param {string} props.helpText - 幫助文本
 * @param {boolean} props.disabled - 是否禁用
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 表單複選框組件
 */
function FormCheckbox({
    id,
    name,
    label,
    checked = false,
    onChange,
    helpText,
    disabled = false,
    className = '',
    ...rest
}) {
    return (
        <div className={`form-checkbox ${className}`}>
            <div className="checkbox-container">
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    {...rest}
                />
                <label htmlFor={id}>{label}</label>
            </div>

            {helpText && (
                <div className="form-help-text">
                    {helpText}
                </div>
            )}
        </div>
    );
}

export default FormCheckbox;